module.exports = __webpack_public_path__ + "static/media/key.941cefa7.svg";